import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar, IonButton} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import './css/general.css';
import styles from './css/Settings.module.css';


interface SettingsProps extends RouteComponentProps {
  // Define the props here
}
interface SettingState {
  // Define the state here
}

class Settings extends React.Component<SettingsProps, SettingState>{
  constructor(props: SettingsProps) {
    super(props);

    this.state = { }
}

goToUserSupport() {
  const {history} = this.props;
      history.push("/usersupport");
  }
  goToFeedback() {
      const {history} = this.props;
      history.push("/feedback");
  }
  goToPrivacyPolicy() {
      const {history} = this.props;
      history.push("/privacy");
  }



  render(){
    return (
      <IonPage>
        <IonHeader class="ion-no-border">
          <IonToolbar>
          <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
            <IonTitle>App info</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
        <div className="whiteBG">
          <div className={(styles.buttons)}>
            <IonButton shape="round" size= "large" onClick={() => this.goToUserSupport()}>User support</IonButton>
            <IonButton shape="round" size= "large" onClick={() => this.goToFeedback()}>Feedback</IonButton>
            <IonButton shape="round" size= "large" onClick={() => this.goToPrivacyPolicy()}>Privacy policy</IonButton>
          </div>
        </div>
        </IonContent>
      </IonPage>
    );
  }
};

export default withRouter(Settings)
